import React from 'react';
import { Grid } from '@mui/material';
import './Footer.scss';

export default function TableFooter(props) {
    return (
        <Grid container className='footer'>
            <Grid item xs={12} sm={6} justifyContent='center' alignItems='center' sx={{display: 'flex'}}>
                <div>
                <h2>Nous contacter</h2>
                <p>Tel : 09 63 69 87 42</p>
                <p>email : <a href='mailto:info@mppc.fr'>info@mppc.fr</a></p>
                </div>
            </Grid>
            <Grid item xs={12} sm={6} justifyContent='center' alignItems='center' sx={{display: 'flex'}}>
                <img src='/splm_logo.png' />
            </Grid>
        </Grid>
    )
}